import script from "./SelectLevelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectLevelModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectLevelModal.vue?vue&type=style&index=0&id=ddeaba36&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddeaba36"]])

export default __exports__